import { ModuleWithProviders, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DwAuthGuardService } from './auth-guard.service';
import { DwAuthorizedService } from './authorized.service';
import { DW_AUTH_TOKEN, DwAuthService } from './auth.service';
import { DwUserService } from './user.service';
import { DwAuthTokenIntercept } from './auth-token-intercept';
import { DwUserStorage } from './user-storage';
var DwAuthModule = /** @class */ (function () {
    function DwAuthModule() {
    }
    DwAuthModule.forRoot = function (providers) {
        return {
            ngModule: DwAuthModule,
            providers: [
                DwAuthGuardService,
                DwAuthorizedService,
                DwAuthService,
                DwUserService,
                DwUserStorage,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: DwAuthTokenIntercept,
                    multi: true
                },
                {
                    provide: DW_AUTH_TOKEN,
                    useValue: {}
                }
            ].concat(providers)
        };
    };
    return DwAuthModule;
}());
export { DwAuthModule };
